@if (!hideFilters || !!actionButtonText || !!actionButtons) {
<div class="grid-actions">
  <div class="grid-actions-tags-container">
    @if (actionButtonText && !actionButtonAsSecondary) {
    <mf-button
      [text]="actionButtonText"
      [disabled]="disableActionButton"
      (click)="actionButtonClick.emit()" />
    } @else if (actionButtonText && actionButtonAsSecondary) {
    <mf-button-secondary
      [text]="actionButtonText"
      [disabled]="disableActionButton"
      (click)="actionButtonClick.emit()" />
    } @for (action of actionButtons; track $index) { @if (action.isSecondary) {
    <mf-button-secondary
      text="{{ action.text }}"
      [icon]="action.icon"
      (click)="onActionButtonClick(action.onClick)"
      [disabled]="action.disabled ?? false"
      [title]="action.title" />
    } @else {
    <mf-button
      text="{{ action.text }}"
      [icon]="action.icon"
      (click)="onActionButtonClick(action.onClick)"
      [disabled]="action.disabled ?? false"
      [title]="action.title" />
    } } @if (!hideFilters) {
    <mf-grid-filter-tags [gridFilterService]="gridFilterService" />
    }
  </div>
  <div class="grid-actions-filters-container">
    @if (!hideFilters && gridFilterService.gridFilters.length > 0) {
    <mf-button-icon
      [icon]="icons.filterList"
      tooltip="Aplicar filtros de búsqueda"
      (click)="openFiltersPopup()">
    </mf-button-icon>
    } @if(mode == gridMode.ServerSide){
    <mf-button-icon
      [icon]="icons.refresh"
      tooltip="Recargar la grilla"
      (click)="refresh()">
    </mf-button-icon>
    }
  </div>
</div>
} @if (rowSelection && selectedCount > 0) {
<div class="grid-selection-info-anchor">
  <span class="grid-selection-info"
    >{{ selectedCount }} {{ selectedCount === 1 ? 'elemento seleccionado' : 'elementos seleccionados' }}</span
  >
</div>
}
<div
  #gridRef
  class="grid">
  <div class="grid-header-row">
    @if(rowSelection) {
    <div class="grid-header-column grid-header-column-select">
      <mf-field-check
        type="checkbox"
        [ngModel]="allSelected"
        (ngModelChange)="selectAll($event)" />
    </div>
    } @for (internalColumn of internalColumns(); track $index) {
    <div
      class="grid-header-column"
      [ngStyle]="{
        flex: internalColumn.calculatedWith + ' 0 0%',
        minWidth: '0',
        textAlign: internalColumn.column.align ?? internalColumn.column.cellOptions?.type == cellValueType.Numeric ? 'right' : undefined
      }"
      title="{{ internalColumn.column.header }}">
      <span class="grid-header-text">
        {{ internalColumn.column.header }}
      </span>
      @if (internalColumn.column.filter) {
      <button
        class="grid-header-button-filter"
        mat-button
        (click)="openFiltersPopup(internalColumn.column)">
        <mf-icon [icon]="icons.filterList" />
      </button>
      } @if (!internalColumn.column.orderByPrevent) {
      <button
        class="grid-header-button-sort"
        mat-button
        (click)="sortBy(internalColumn.column)">
        <mf-icon
          [class.sorting]="isSortingBy(internalColumn.column)"
          icon="{{ isSortingByAsc(internalColumn.column) ? icons.expandLess : icons.expandMore }}" />
      </button>
      }
    </div>
    } @if (menuItems) {
    <div
      class="grid-header-column"
      style="flex: 48px 0 0; display: block"></div>
    }
  </div>

  <div
    #gridBody
    class="grid-body">
    @if (isLoading()) {
    <div class="grid-row">
      <div class="grid-column loading">
        <mf-spinner></mf-spinner>
        Cargando...
      </div>
    </div>
    } @if (!isLoading()) { @if (page() && page()?.pageItemList?.length) { @for (row of page()?.pageItemList; track $index) {
    <div
      class="grid-row"
      [ngClass]="mapRowClass(row)">
      @if (rowSelection) {
      <div
        class="grid-column text-center"
        style="flex: 48px 0 0; display: block; padding: 0">
        <mf-field-check
          type="checkbox"
          [ngModel]="row.selected"
          (ngModelChange)="selectItem(row)" />
      </div>
      } @for (internalColumn of internalColumns(); track $index) {
      <div
        class="grid-column"
        [ngStyle]="{
          flex: internalColumn.calculatedWith + ' 0 0%',
          minWidth: '0',
          textAlign: internalColumn.column.align ?? internalColumn.column.cellOptions?.type == cellValueType.Numeric ? 'right' : undefined
        }"
        title="{{ renderColumnValue(row, internalColumn.column) }}"
        [innerHTML]="renderColumnValue(row, internalColumn.column)"></div>
      } @if (menuItems) {
      <div
        class="grid-column text-center"
        style="flex: 48px 0 0; display: block; padding: 0">
        <mf-grid-menu
          [menuItems]="menuItems"
          [item]="row.item" />
      </div>
      }
    </div>
    } } @if (!page() || page()?.pageItemList?.length == 0) {
    <div class="grid-row">
      @if (errorMessage) {
      <div class="grid-column error-message">
        {{ errorMessage }}
      </div>
      } @if (!errorMessage) {
      <div class="grid-column no-data">No hay datos para mostrar</div>
      }
    </div>
    } }
  </div>
  @if (searchDto && page()) {
  <mf-grid-paginator
    [page]="page()!"
    [searchDto]="searchDto"
    [useContinuationToken]="useContinuationToken"
    (pageChangeEvent)="onPaginatorEvent($event)" />
  }
</div>
